// Module
var code = "<plan-form\n  model=\"vm.plan\"\n  zay=\"vm.zay\"\n  zay-client=\"vm.zayClient\"\n  avtos=\"vm.avtos\"\n  priceps=\"vm.priceps\"\n  our-firms=\"vm.ourFirms\"\n  copied-plan=\"vm.copiedPlan\"\n  on-save=\"$close(model)\"\n  on-close=\"$close()\"\n></plan-form>\n";
// Exports
module.exports = code;